import { ApolloError, useQuery } from "@apollo/client";
import { GET_POLICY_ACTIONS } from "graphql/queries";
import { PolicyAction } from "types";

export function useProjectActions(projectId: string | undefined): [PolicyAction[], boolean, ApolloError | undefined] {
    const { data, loading, error } = useQuery<{ policyActions: PolicyAction[] }>(GET_POLICY_ACTIONS, {
        variables: { projectId },
        errorPolicy: "all",
        skip: !projectId
    });

    return [data ? data.policyActions : [], loading, error];
}
